// app/services/book/admin_saved_tours.js
import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildUrl = (endpoint) =>
  `${API_ROUTES.BOOK.BASE}${API_ROUTES.BOOK.ADMIN_SAVED_TOURS}/${endpoint ? endpoint : ""}`

export const adminSavedToursService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAdminSavedToursCompanies: builder.query({
      query: () => ({
        url: buildUrl("companies"),
        method: "GET",
      }),
      providesTags: ["AdminSavedToursCompanies"],
    }),
    getAdminSavedToursOverview: builder.query({
      query: (params) => ({
        url: buildUrl("index_data"),
        method: "GET",
        params,
      }),
      providesTags: ["AdminSavedToursOverview"],
    }),
    getAdminSavedToursSessions: builder.query({
      query: (params) => ({
        url: buildUrl("sessions"),
        method: "GET",
        params,
      }),
      providesTags: ["AdminSavedToursSessions"],
    }),
    getAdminSavedToursSession: builder.query({
      query: (sessionKey) => ({
        url: buildUrl(`session_json/${sessionKey}`),
        method: "GET",
      }),
      providesTags: (result, error, sessionKey) => [
        { type: "AdminSavedToursSession", id: sessionKey },
      ],
    }),
  }),
})

export const {
  useLazyGetAdminSavedToursCompaniesQuery,
  useLazyGetAdminSavedToursOverviewQuery,
  useLazyGetAdminSavedToursSessionsQuery,
  useLazyGetAdminSavedToursSessionQuery,
} = adminSavedToursService
